import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Typography } from "@mui/material";
import { baseTheme } from "../../../themes/shipinsure";

const META_TEXT = "#1E293B";
const ICON_COLOR = "#475569";

export function CoverageSummary({ claim, isAwaitingReview, t }) {
  const rows = [
    {
      key: "protection",
      value: claim.order?.has_package_protection
        ? t("status.coverageActive")
        : t("status.coverageInactive"),
    },
  ];

  if (!isAwaitingReview) {
    rows.push({
      key: "return",
      value: t("status.coverage.returnRequired"),
    });
  }

  return (
    <Box
      mb="16px"
      sx={{
        border: "1px solid #C5D0E0",
        borderRadius: "12px",
        padding: "16px",
      }}
    >
      <Typography
        variant="h6"
        mb="12px"
        fontSize="1.1rem"
        fontWeight={700}
        color={baseTheme.colors.text}
      >
        {t("status.coverage.title")}
      </Typography>
      {rows.map((row) => (
        <Box
          key={row.key}
          display="flex"
          alignItems="flex-start"
          gap="8px"
          mb="8px"
        >
          <InfoOutlinedIcon
            sx={{ fontSize: 18, color: ICON_COLOR, mt: "2px" }}
          />
          <Typography fontSize="15px" color={META_TEXT}>
            {row.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
